import lrz from 'lrz';
export default {
  name: '',
  props: {
    size: {
      type: Number,
      default: 10
    },
    isCompress: {
      type: Boolean,
      default: false
    },
    config: {
      type: Object,
      default: function () {
        return {};
      }
    },
    showFileList: {
      type: Boolean,
      default: false
    },
    listType: {
      type: String,
      default: '' // text/picture/picture-card
    },
    limit: {
      type: Number,
      default: 10
    },
    fileList: {
      type: Array,
      default: function () {
        return [];
      }
    },
    category: {
      type: String,
      default: 'COL01'
    }
  },
  data() {
    return {
      hideUp: false,
      file: {
        autoUpload: true,
        action: '/api/v1.0/multiparts/images/upload',
        headers: {
          'x-rongxin-category': 'COL01'
        },
        uploadData: {}
      },
      previewImage: {
        visible: false,
        url: ''
      }
    };
  },
  watch: {
    fileList: {
      handler (list) {
        this.hideUp = list.length >= this.limit ? true : false;
      },
      deep: true,
      immediate: true
    }
  },
  created() {
  },
  methods: {
    dataURLtoFile2(Blob, filename) {
      return new File([Blob], filename, { type: Blob.type });
    },
    imgCompress(file) {
      const reference = this.$refs.upload;
      let file_index = -1;
      reference.uploadFiles.forEach((item, index) => {
        if (item.raw === file) {
          file_index = index;
          return;
        }
      });
      // let index = reference.uploadFiles.indexOf(file);
      console.log(reference, file_index);

      return lrz(file).then(rst => {
        console.log('【图片压缩成功】', rst);
        // let tempFile = this.dataURLtoFile(rst.base64, rst.origin.name);
        let tempFile = this.dataURLtoFile2(rst.file, rst.origin.name);
        // tempFile.uid = rst.origin.uid;
        // reference.uploadFiles[file_index].raw = tempFile;
        // reference.uploadFiles[file_index].size = rst.fileLen;

        console.log('【新文件】', tempFile, reference);
        return tempFile;
        // this.$refs.imageUploadRef.submit();
      }).catch(function(error) {
        console.log('【图片压缩失败】', error);
      }).always(function() {
      });
    },
    imageBeforeUpload(file) {
      const arr = ['jpg', 'jpeg', 'png'];
      if (!arr.find(item => file.type.indexOf(item) !== -1)) {
        this.$errorMessage('图片仅支持jpg，jpeg，png格式!');
        return false;
      }
      if (file.size / 1024 / 1024 > this.size) {
        this.$errorMessage('图片大小请限制在' + this.size + 'M以内！');
        return false;
      }
      const isSize = new Promise((resolve, reject) => {
        const _URL = window.URL || window.webkitURL;
        const img = new Image();
        img.onload = () => {
          const imgWidth = img.width;
          const imgHight = img.height;
          if (!this.config.width || !this.config.height) {
            return resolve();
          }
          this.uploadData.width = Math.floor(this.config.width);
          this.uploadData.height = Math.floor(this.config.height);
          let valid = imgWidth === this.config.width && imgHight === this.config.height;
          valid ? resolve() : reject();
        };
        img.src = _URL.createObjectURL(file);
      }).then(() => {
        if (this.isCompress && (file.size / 1024 / 1024) > 1) {
          console.log('【压缩前】', file);
          const newFile = this.imgCompress(file);
          console.log('【压缩后】', newFile);
          return newFile;
        } else {
          return file;
        }
        // return true;
      }, () => {
        this.$errorMessage('请上传' + this.config.width + '*' + this.config.height +'的图片');
        return Promise.reject(false);
      });
      return isSize;
    },
    imageChange(file, fileList) {
      this.hideUp = fileList.length >= this.limit;
      console.log('change', file, fileList);
    },
    imageRemove(file, fileList) {
      const list = fileList.map(item => {
        return item.response[0].image;
      });
      this.$emit('upload', list);
    },
    handleUpSuccess(response, file, fileList) {
      const list = fileList.map(item => {
        return item.response[0].image;
      });
      this.$emit('upload', list);
    },
    handleUpError(error) {
      this.$errorMessage(error.reason);
    },
    handleExceed() {
      this.$errorMessage('图片选择超出限制数量!');
    },
    handlePreview(file) {
      this.previewImage = {
        visible: true,
        url: file.url
      };
    }
  }
};
